import { gql } from '@apollo/client';
import { ROUTE_PATTERN_LLMS_TXT, BLAZE_STATIC_ROUTE_STORE_KEY } from '../../constants';
import getHandler from './generic-file-handler';

const storeKey = process.env.BLAZE_STATIC_ROUTE_STORE_KEY || BLAZE_STATIC_ROUTE_STORE_KEY;

export const fileQuery = gql`
  query {
    files: getFiles(
      where: { storeKey: "${storeKey}", filename: "llms.txt" }
      limit: 1
      sort: [{ property: "created", direction: "desc" }]
    ) {
      mimetype
      url
    }
  }
`;

export const pattern = new RegExp(ROUTE_PATTERN_LLMS_TXT);

export const handler = getHandler(fileQuery);
